module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "wind-icon",
    class: _vm.classes,
    style: (_vm.iconStyle),
    on: {
      "click": _vm.onIconClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37253b5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/wind-ui/package/icon/index.vue
// module id = 556
// module chunks = 1